import configurl from '@/config/user.env';
import utils from '@/components/utils/common.js';
import {
    getCustomerImport,
    invoiceTemplateDownloadApi

} from '@mdm/api/customer/repaymentPlan.js';

export const config = {
    name: 'repaymentPlan',
    searchFields: [
        {
            name: '月份',
            value: 'periodMonth',
            isFixed: true,
            type: 'date',
            timeType: 'month',
            pickerOptions: {},
            format: 'yyyy-MM',
            disabled: false,
            valueFormat: 'yyyy-MM',
            span: 3
        },
        {
            name: '状态',
            value: 'lockFlag',
            type: 'select',
            optionNum: 'LOCK_FLAG',
            multiple: false,
            isFixed: true,
            span: 3
        },

        // {
        //     name: '客户系',
        //     value: 'lmsCustomerDeptName',
        //     type: 'advance',
        //     isFixed: true,
        //     span: 3,
        //     advanceConfig: [
        //         { prop: 'customerGroupName', value: '客户系名称' }
        //     ],
        //     tableConfig: [
        //         { prop: 'customerGroupName', value: '客户系名称' },
        //         { prop: 'calCustomerLevelCode', value: '客户等级', type: 'select', optionsKey: 'NEOCRM_CUSTOMER_LEVEL' },
        //         { prop: 'customerGroupCode', value: '行业类型', type: 'select', optionsKey: 'SYS_INDUSTRY_TYPE' },
        //         { prop: 'industryCategory', value: '行业大类', type: 'select', optionsKey: 'SYS_SUPPLIER_INDUSTRY' }
        //     ],
        //     prefix: '/api-lcrm',
        //     advanceUrl: '/customer/group/info/page',
        //     cbParams: ['customerGroupCode#lmsCustomerDeptCode', 'customerGroupName#lmsCustomerDeptName'],
        //     advanceCode: 'advanceCode'
        // },
        {
            name: '分公司',
            value: 'companyName',
            type: 'advance',
            // maxNum: 10, // 多选条数限制
            isFixed: true,
            span: 3,
            advanceConfig: [
                { 'prop': 'companyNameCn', 'value': '分公司名称' },
                { 'prop': 'companyCode', 'value': '分公司编码' }
            ],
            tableConfig: [
                { 'prop': 'companyNameCn', 'value': '分公司名称', 'displayName': 'companyNameCn' },
                { 'prop': 'companyCode', 'value': '分公司编码' }
            ],
            prefix: '/api-mdm',
            advanceUrl: `/esCompany/popCompany`,
            cbParams: ['companyCode#companyCode', 'companyNameCn#companyName']
        },

        {
            name: '客户名称',
            value: 'customerName',
            type: 'advance',
            advanceConfig: [
                { prop: 'customerName', value: '客户名称', 'displayName': 'customerName' },
                { prop: 'customerCode', value: '客户编码' }
            ],
            tableConfig: [
                { prop: 'customerName', value: '客户名称', 'displayName': 'customerName' },
                { prop: 'customerCode', value: '客户编码' }
            ],
            method: 'post',
            prefix: '/api-lcrm',
            advanceUrl: '/customer/info/page',
            cbParams: [
                'customerCode#customerCode',
                'customerName#customerName'
            ],
            isFixed: true,
            span: 3
        },
        {
            name: '行业大类',
            value: 'industryCategoriesCode',
            type: 'cascader',
            props: {
                multiple: true,
                value: 'industryCode',
                label: 'industryName'
            },
            options: [],
            // options: [{
            //     industryCategoriesCode: '1',
            //     industryCategoriesName: 'mingc1',
            //     industryList: [{
            //         industryCategoriesCode: '2',
            //         industryCategoriesName: 'mingc2'
            //     },
            //     {
            //         industryCategoriesCode: '23',
            //         industryCategoriesName: '23'
            //     }]
            // }],
            isFixed: true,
            multiple: true,
            span: 4
        }

    ],
    selection: true,
    index: false,
    columns: [
        {
            label: '会计主体名称',
            prop: 'ouName',
            width: 140
        },
        {
            label: '会计主体编码',
            prop: 'ouCode',
            width: 140
        },
        {
            label: '分公司名称',
            prop: 'companyName',
            width: 140
        },
        {
            label: '分公司编码',
            prop: 'companyCode',
            width: 140
        },
        {
            label: '经营中心名称',
            prop: 'centerName',
            width: 140
        },
        {
            label: '经营中心编码',
            prop: 'centerCode',
            width: 140
        },
        {
            label: '服务平台名称',
            prop: 'siteName',
            width: 140
        },
        {
            label: '服务平台编码',
            prop: 'siteCode',
            width: 140
        },
        {
            label: '客户编码',
            prop: 'customerCode',
            width: 140
        },
        {
            label: '客户名称',
            prop: 'customerName',
            width: 140
        },
        {
            label: '客户属性',
            prop: 'customerChannel',
            type: 'slot',
            slot: true,
            editSlot: true,
            optionsKey: 'LMDM_CUSTOMER_CHANNEL',
            width: 90
        },
        {
            label: '分析客户',
            prop: 'analyzedCustomerName', // weiding
            width: 140
        },
        {
            label: '客户系',
            prop: 'customerGroupName',
            width: 90
        },
        {
            label: '客户类型',
            prop: 'calCustomerLevelCode', // weiding
            type: 'slot',
            slot: true,
            editSlot: true,
            optionsKey: 'NEOCRM_CUSTOMER_LEVEL',
            width: 90
        },
        {
            label: '行业大类',
            prop: 'industryCategoriesName',
            width: 100
        },
        {
            label: '细分行业',
            prop: 'industryTypeName',
            width: 100
        },
        {
            label: '开票计划（万元）',
            prop: 'invoicePlanAmount',
            width: 120
        },
        {
            label: '开票完成（万元）',
            prop: 'invoiceFinishAmount',
            width: 120
        },
        {
            label: '开票计划缺口（万元）',
            prop: 'invoicePlanGap', // weiding
            tooltip: `等于 开票计划 - 开票完成`,
            width: 165
        },
        {
            label: '开票预计完成10日（万元）',
            prop: 'invoicePlan10d',
            type: 'slot',
            slot: true,
            editSlot: true,
            width: 170
        },
        {
            label: '开票预计完成20日（万元）',
            prop: 'invoicePlan20d',
            type: 'slot',
            slot: true,
            editSlot: true,
            width: 170
        },
        {
            label: '开票在途缺口（万元）',
            prop: 'invoiceInTransitGap', // weiding
            tooltip: `开票预计完成20日不为空，等于 开票预计完成20日 -  开票完成
                否则等于 开票预计完成10日 - 开票完成`,
            width: 160
        },
        {
            label: '开票计划预计偏差（万元）',
            prop: 'invoicePlanExpectedDeviation', // weiding
            tooltip: `开票预计完成20日不为空，等于 开票计划 - 开票预计完成20日
                否则等于 开票计划 - 开票预计完成10日`,
            width: 185
        },
        {
            label: '开票确认人(mip姓名)',
            prop: 'invoiceConfirmUserName',
            width: 140
        },
        {
            label: '开票确认人(mip账号)',
            prop: 'invoiceConfirmUserCode',
            width: 140
        },
        {
            label: '开票异常类型',
            prop: 'invoiceErrorType',
            type: 'slot',
            slot: true,
            editSlot: true,
            optionsKey: 'INVOICE_PLAN_ERROR_TYPE', // TODO
            width: 140
        },
        {
            label: '开票备注说明',
            prop: 'invoiceRemark',
            inputType: 'textarea',
            type: 'slot',
            slot: true,
            editSlot: true,
            rows: 3,
            width: 140
        },
        {
            label: '回款计划（万元）',
            prop: 'rebillPlanAmount',
            width: 140
        },
        {
            label: '回款完成（万元）',
            prop: 'rebillFinishAmount',
            width: 140
        },
        {
            label: '回款计划缺口（万元）',
            prop: 'rebillPlanGap',
            tooltip: `等于 回款计划 - 回款完成`,
            width: 165
        },
        {
            label: '回款预计完成10日（万元）',
            prop: 'rebillPlan10d',
            type: 'slot',
            slot: true,
            editSlot: true,
            width: 170
        },
        {
            label: '回款预计完成20日（万元）',
            prop: 'rebillPlan20d',
            type: 'slot',
            slot: true,
            editSlot: true,
            width: 170
        },
        {
            label: '回款在途缺口（万元）',
            prop: 'rebillInTransitGap',
            tooltip: `回款预计完成20日不为空，等于 回款预计完成20日 - 回款完成
                否则等于 回款预计完成10日 - 回款完成`,
            width: 170
        },
        {
            label: '回款计划预计偏差（万元）',
            prop: 'rebillPlanExpectedDeviation',
            tooltip: `回款预计完成20日不为空，等于  回款计划 - 回款预计完成20日
                否则等于  回款计划 - 回款预计完成10日`,
            width: 185
        },
        {
            label: '回款确认人(mip姓名)',
            prop: 'rebillConfirmUserName',
            width: 140
        },
        {
            label: '回款确认人(mip账号)',
            prop: 'rebillConfirmUserCode',
            width: 140
        },
        {
            label: '回款异常类型',
            prop: 'rebillErrorType',
            type: 'slot',
            slot: true,
            editSlot: true,
            optionsKey: 'REBILL_PLAN_ERROR_TYPE', // TODO
            width: 140
        },
        {
            label: '回款备注说明',
            prop: 'rebillRemark',
            inputType: 'textarea',
            type: 'slot',
            slot: true,
            editSlot: true,
            rows: 3,
            width: 140
        },
        {
            label: '年月',
            prop: 'periodMonthConvert',
            width: 140
        },
        {
            label: '状态',
            prop: 'lockFlag',
            type: 'slot',
            slot: true,
            editSlot: true,
            optionsKey: 'LOCK_FLAG',
            width: 140
        },
        {
            label: '创建时间',
            prop: 'createTime',
            width: 140
        },
        {
            label: '更新时间',
            prop: 'updateTime',
            width: 140
        }
    ],
    actions: { // 表格操作列的配置
        fixedWidth: 160, // fixedWidth（可选） 设置操作列的固定宽度，不加该参数默认是按钮list长度*50px
        list: [

        ]
    },
    importConfig: {
        action: configurl.apiUrl + 'api-lcrm/contractEnclosureInfo/upload',
        downloadApi: invoiceTemplateDownloadApi,
        importApi: getCustomerImport,
        downParams: {
            fileName: '外部客户应收管控表导入模板.xlsx'
        },
        multiple: false,
        accept: 'xlsx',
        downBtn: false,
        showFileList: false,
        fileType: '只能上传Excel文件',
        manualUpload: true
    }
};
/**
 * @description 判断当前时间是否大于等于数据年月的所在月16号
 * @param {string|number} time 数据年月，格式：YYYY-MM 或 YYYYMM
 * @returns {boolean} true: 当前时间 >= 指定月份16号，false: 当前时间 < 指定月份16号
 */
export const isCurrentTimeAfterOrEqualMonth16th = (time, day = '16') => {
    const yearMonth = utils.formatDateTime(time, 'YYYY-MM');
    if (!yearMonth) return false;
    // 格式化年月输入
    let formattedYearMonth;
    if (typeof yearMonth === 'string') {
        if (yearMonth.includes('-')) {
            formattedYearMonth = yearMonth;
        } else {
            formattedYearMonth = `${yearMonth.substring(0, 4)}-${yearMonth.substring(4, 6)}`;
        }
    } else if (typeof yearMonth === 'number') {
        formattedYearMonth = `${Math.floor(yearMonth / 100)}-${String(yearMonth % 100).padStart(2, '0')}`;
    } else {
        return false;
    }

    // 构建指定月份16号的日期对象
    const [year, month] = formattedYearMonth.split('-');
    const targetDate = new Date(`${year}-${month.padStart(2, '0')}-${day}T00:00:00`);

    // 获取当前时间
    const currentDate = new Date();
    return currentDate >= targetDate;
};

/**
 * @description 判断当前时间是否大于等于数据年月的所在月22号
 * @param {string|number} time 数据年月，格式：YYYY-MM 或 YYYYMM
 * @returns {boolean} true: 当前时间 >= 指定月份22号，false: 当前时间 < 指定月份22号
 */
export const isCurrentTimeAfterOrEqualMonth22th = (time, day = '22') => {
    const yearMonth = utils.formatDateTime(time, 'YYYY-MM');
    if (!yearMonth) return false;

    // 格式化年月输入
    let formattedYearMonth;
    if (typeof yearMonth === 'string') {
        if (yearMonth.includes('-')) {
            formattedYearMonth = yearMonth;
        } else {
            formattedYearMonth = `${yearMonth.substring(0, 4)}-${yearMonth.substring(4, 6)}`;
        }
    } else if (typeof yearMonth === 'number') {
        formattedYearMonth = `${Math.floor(yearMonth / 100)}-${String(yearMonth % 100).padStart(2, '0')}`;
    } else {
        return false;
    }

    // 构建指定月份22号的日期对象
    const [year, month] = formattedYearMonth.split('-');
    const targetDate = new Date(`${year}-${month.padStart(2, '0')}-${day}T00:00:00`);

    // 获取当前时间
    const currentDate = new Date();
    return currentDate >= targetDate;
};
